import * as React from "react";
import { useState, useMemo } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import AddCollectionFormGroup from "collections/components/AddCollectionFormGroup";
import { createGRN, getValuesFromGRN } from "logic/permissions/GRN";
import useEntityMembershiPolicies from "collections/hooks/useEntityMembershipPolicies";
import { Spinner } from "components/common";
import { useTranslation } from "react-i18next";
const SubmitButton = styled(Button)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.md};
    align-self: end;
  `
);
const FormElements = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacings.md};
  `
);
const Container = styled.div`
  flex: 1;
`;
const CollectionsSelector = ({ entityId, entityType, onSubmit }) => {
  const { t } = useTranslation("enterprise_collections");
  const {
    data: entityMembershipPolicies,
    isLoading: isLoadingEntityMembershipPolicies,
    refetch: refetchEntityMembershipPolicies
  } = useEntityMembershiPolicies(entityId, entityType, { enabled: true });
  const [selectedcollectionsIds, setSelectedCollectionsIds] = useState(null);
  const handleCollectionsChange = (value) => {
    const ids = value.selected_collections.map((c) => getValuesFromGRN(c).id);
    setSelectedCollectionsIds(ids);
  };
  const handleSubmit = () => {
    onSubmit(selectedcollectionsIds);
    refetchEntityMembershipPolicies();
  };
  const initialValue = useMemo(
    () => entityMembershipPolicies == null ? void 0 : entityMembershipPolicies.map((v) => createGRN("collection", v.target_id)),
    [entityMembershipPolicies]
  );
  if (isLoadingEntityMembershipPolicies) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(FormElements, null, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    AddCollectionFormGroup,
    {
      label: t("collections_selector.label"),
      hideHelp: true,
      filterValueFromOption: true,
      entityType,
      onChange: handleCollectionsChange,
      overrideExclude: true,
      value: initialValue
    }
  )), /* @__PURE__ */ React.createElement(
    SubmitButton,
    {
      bsStyle: "primary",
      disabled: !selectedcollectionsIds,
      onClick: handleSubmit,
      title: t("collections_selector.submit_title"),
      type: "button"
    },
    t("collections_selector.submit")
  ));
};
export default CollectionsSelector;
